import { createContext } from "react";
export var AuthContext = createContext({
    userInfo: null,
    infoDetran: undefined,
    loading: false,
});
